import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";

import { HashPreservingLink } from "@/components/HashPreservingLink";
import { Icon } from "@/components/Icon";
import { QuantityWithUOMAbbr } from "@/components/QuantityWithUOMAbbr";
import { getSosEntityHashId } from "@/components/SosEntityHashLink";
import { JobTrackingInternalLink } from "../JobTrackingInternalLink";
import { withJobTrackingData } from "../withJobTrackingData";
import { ExistingInventorySourceList, ExistingInventorySourceListProps } from "./ExistingInventorySourceList";

export const ExistingInventoryQuantityTableCell: React.FC<Omit<ExistingInventorySourceListProps, "sources">> =
  withJobTrackingData(({ item, fromRowId, existingInventoryByItemId }) => {
    const existingInventory = existingInventoryByItemId.get(item.id);
    if (!existingInventory) return 0;

    return (
      <OverlayTrigger
        trigger="focus"
        overlay={(props) => (
          <Popover {...props} style={{ ...props.style, "--bs-popover-max-width": "500px" }}>
            <Popover.Header as="h3">
              Existing Inventory for {item.name}{" "}
              <JobTrackingInternalLink trackerPath="existing-inventory">
                {({ targetPath, targetPageTitle }) => (
                  <HashPreservingLink
                    fromHash={fromRowId}
                    to={targetPath + "#" + getSosEntityHashId("item", item.id)}
                    title={`View on '${targetPageTitle}' page`}
                  >
                    <Icon icon="link-45deg" />
                  </HashPreservingLink>
                )}
              </JobTrackingInternalLink>
            </Popover.Header>
            <Popover.Body>
              <ExistingInventorySourceList item={item} sources={existingInventory.sources} fromRowId={fromRowId} />
            </Popover.Body>
          </Popover>
        )}
      >
        <button className="btn btn-link p-0" title="Click to see breakdown">
          <QuantityWithUOMAbbr quantity={existingInventory.quantity.balance} uom={item.baseItemUOM?.uom} />
        </button>
      </OverlayTrigger>
    );
  });
